<template>
	<div>
		<form @submit.prevent="save">
			<div class="row mb-3">
				<div class="col-12 col-md-6">
					<h1><em class="fas fa-bus-alt"></em> <span v-if="run.run_id"><span v-show="NSTS_CONFIG['show_route_id']">{{run.route_id}}: </span>{{run.run_id}}<span v-show="NSTS_CONFIG['show_vehicle_class']"> ({{run.vehicle_class}})</span></span></h1>
				</div>
				<div class="col-12 col-md-6 text-right">
					<button type="button" class="btn btn-secondary ml-1 mb-1" @click="$router.push('/').catch(function() { /* ignore error */ })"><em class="fas fa-times" aria-hidden="true"></em> Close</button>
					<button v-if="canEdit" type="submit" class="btn btn-primary ml-1 mb-1"><em class="fas fa-save" aria-hidden="true"></em> Save</button>
					<br>
					<button v-show="canEdit" type="button" class="btn btn-sm btn-warning ml-1 mb-1" @click="reset()"><em class="fas fa-trash-alt" aria-hidden="true"></em> Reset</button>
					<button v-show="canEdit" type="button" class="btn btn-sm btn-success ml-1 mb-1" @click="autofill()"><em class="fas fa-magic" aria-hidden="true"></em> Autofill</button>
					<button v-show="canEdit" type="button" class="btn btn-sm btn-success ml-1 mb-1" @click="refresh()"><em class="fas fa-sync-alt" aria-hidden="true"></em> Refresh</button>
					<a :href="NSTS_CONFIG['api_server'] + '/runs/' + $route.params.run_id + '/pdf'" class="btn btn-sm btn-success ml-1 mb-1" target="_blank"><em class="fas fa-file-pdf"></em> Download</a>
				</div>
				<div class="col-12" v-show="canEdit && hasPair">
					<div class="alert alert-info text-center" v-if="hasQualifyingPair === true">
						<em class="fas fa-info-circle"></em> Would you like to automatically make {{run.pair.run_id}} match {{run.run_id}} when saved?
						<div class="custom-control custom-switch d-inline-block ml-3">
							<input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="saveBoth">
							<label class="custom-control-label" for="customSwitch1">
								<span v-show="saveBoth">Yes</span>
								<span v-show="!saveBoth">No</span>
							</label>
						</div>
					</div>
					<div class="alert alert-info text-center" v-if="hasQualifyingPair === 1">
						<em class="fas fa-info-circle"></em> {{run.pair.run_id}} uses a different vehicle than {{run.run_id}} and therefore can not be updated together.
					</div>
					<div class="alert alert-info text-center" v-if="hasQualifyingPair === 2">
						<em class="fas fa-info-circle"></em> {{run.pair.run_id}} has different students than {{run.run_id}} and therefore can not be updated together.
					</div>
				</div>
			</div>

			<div class="form-row mb-1">
				<div class="col-6"><em class="fas fa-user-tie fa-2x"></em> <b>DRIVER</b></div>
				<div class="col-6 text-right"><b>DOOR</b> <em class="fas fa-door-open fa-2x"></em></div>
			</div>

			<div v-for="(row, row_num) in run.seats" :key="row_num" class="form-row mb-1">
				<div v-for="(seat, seat_num) in row" :key="seat_num" :class="seatClass(seat_num)">
					<div v-for="(i, index) in seatLoops" :key="i" class="mb-1">
						<div v-show="seat == null"><!-- blank space --></div>
						<div v-show="seat != null && seat.isle == true && runDir(run) == 'PU'">
							<div class="d-flex justify-content-between">
								<span class="form-control-sm">
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'down' && NSTS_CONFIG['row_ordering'] == 'normal'">{{row_num + 1}} </span>
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'down' && NSTS_CONFIG['row_ordering'] == 'reverse'">{{row_num + run.seats.length + 1}} </span>
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'across' && NSTS_CONFIG['row_ordering'] == 'normal'">{{(row_num * 2) + 1}} </span>
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'across' && NSTS_CONFIG['row_ordering'] == 'reverse'">{{(row_num * 2) + 2}} </span>
								</span>
								<span class="form-control-sm">
									<span v-show="index == 0 && run.transfer_school_id != null"><em class="fas fa-home"></em><em class="fas fa-fw fa-caret-right"></em><span v-show="run.transfer_school_id != null">{{run.transfer_school_id}}</span><span v-show="run.transfer_school_id == null">{{run.school_id}}</span></span>
									<span v-show="index == 1">{{run.transfer_school_id}}<em class="fas fa-fw fa-caret-right"></em><span v-show="run.transfer2_school_id != null">{{run.transfer2_school_id}}</span><span v-show="run.transfer2_school_id == null">{{run.school_id}}</span></span>
									<span v-show="index == 2">{{run.transfer2_school_id}}<em class="fas fa-fw fa-caret-right"></em><span v-show="run.transfer3_school_id != null">{{run.transfer3_school_id}}</span><span v-show="run.transfer3_school_id == null">{{run.school_id}}</span></span>
									<span v-show="index == 3">{{run.transfer3_school_id}}<em class="fas fa-fw fa-caret-right"></em>{{run.school_id}}</span>
								</span>
								<span class="form-control-sm">
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'down' && NSTS_CONFIG['row_ordering'] == 'normal'"> {{row_num + run.seats.length + 1}}</span>
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'down' && NSTS_CONFIG['row_ordering'] == 'reverse'"> {{row_num + 1}}</span>
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'across' && NSTS_CONFIG['row_ordering'] == 'normal'"> {{(row_num * 2) + 2}}</span>
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'across' && NSTS_CONFIG['row_ordering'] == 'reverse'"> {{(row_num * 2) + 1}}</span>
								</span>
							</div>
						</div>
						<div v-show="seat != null && seat.isle == true && runDir(run) == 'DO'">
							<div class="d-flex justify-content-between">
								<span class="form-control-sm">
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'down' && NSTS_CONFIG['row_ordering'] == 'normal'">{{row_num + 1}} </span>
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'down' && NSTS_CONFIG['row_ordering'] == 'reverse'">{{row_num + run.seats.length + 1}} </span>
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'across' && NSTS_CONFIG['row_ordering'] == 'normal'">{{(row_num * 2) + 1}} </span>
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'across' && NSTS_CONFIG['row_ordering'] == 'reverse'">{{(row_num * 2) + 2}} </span>
								</span>
								<span class="form-control-sm">
									<span v-show="index == 0 && run.transfer_school_id != null">{{run.school_id}}<em class="fas fa-fw fa-caret-right"></em><span v-show="run.transfer_school_id != null">{{run.transfer_school_id}}</span><span v-show="run.transfer_school_id == null"><em class="fas fa-home"></em></span></span>
									<span v-show="index == 1">{{run.transfer_school_id}}<em class="fas fa-fw fa-caret-right"></em><span v-show="run.transfer2_school_id != null">{{run.transfer2_school_id}}</span><span v-show="run.transfer2_school_id == null"><em class="fas fa-home"></em></span></span>
									<span v-show="index == 2">{{run.transfer2_school_id}}<em class="fas fa-fw fa-caret-right"></em><span v-show="run.transfer3_school_id != null">{{run.transfer3_school_id}}</span><span v-show="run.transfer3_school_id == null"><em class="fas fa-home"></em></span></span>
									<span v-show="index == 3">{{run.transfer3_school_id}}<em class="fas fa-fw fa-caret-right"></em><em class="fas fa-home"></em></span>
								</span>
								<span class="form-control-sm">
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'down' && NSTS_CONFIG['row_ordering'] == 'normal'"> {{row_num + run.seats.length + 1}}</span>
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'down' && NSTS_CONFIG['row_ordering'] == 'reverse'"> {{row_num + 1}}</span>
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'across' && NSTS_CONFIG['row_ordering'] == 'normal'"> {{(row_num * 2) + 2}}</span>
									<span v-show="index == 0 && NSTS_CONFIG['row_numbering'] == 'across' && NSTS_CONFIG['row_ordering'] == 'reverse'"> {{(row_num * 2) + 1}}</span>
								</span>
							</div>
						</div>
						<div v-show="seat != null && seat.isle == false && (seat.available == false || seat.priority == 1)" class="text-center" @mouseover="tooltip(seat, index, $event)">{{NSTS_CONFIG["do_not_use_text"]}}</div>
						<div v-if="seat != null && seat.isle == false && seat.available == true && seat.priority != 1" class="text-center">
							<select class="form-control custom-select custom-select-sm" v-model="seat.student_id[index]" @change="reseat(seat, index)" @mouseover="tooltip(seat, index, $event)" :disabled="!canEdit || (seat.student[index] != null && current_user.school_ids.indexOf(seat.student[index].school_id) == -1 && !canEditOthers)">
								<option :value="null" v-if="seat.priority == 2">{{NSTS_CONFIG["overflow_text"]}}</option>
								<option :value="null" v-if="seat.priority == 3">Empty</option>
								<option v-for="student in sortedStudents" :key="student.student_id" :value="student.student_id" :disabled="!canEdit || (current_user.school_ids.indexOf(student.school_id) == -1 && !canEditOthers) || !studentOnLeg(student.student_id, index)">
									<span v-if="!student.seated">***</span> <span v-if="NSTS_CONFIG['show_school_in_list']">{{student.school_id}}: </span><span v-if="current_user.school_ids.indexOf(student.school_id) != -1 || canViewOthers">{{student.lname}}, {{student.fname.substring(0, 1)}}</span><span v-if="current_user.school_ids.indexOf(student.school_id) == -1 && !canViewOthers">{{NSTS_CONFIG['redacted_name']}}</span> (<span v-if="NSTS_CONFIG['show_grade_label_in_list']">grade </span>{{student.grade}})
								</option>
							</select>
						</div>
						<div v-show="seat != null && seat.accessible == true" class="text-center"><em class="fas fa-wheelchair text-info" @mouseover="tooltip(seat, index, $event)"></em></div>
					</div>
				</div>
				<div class="col-12" v-show="seatLoops > 1 && row_num != run.seats.length - 1"><hr></div>
			</div>

			<div class="form-row mb-5">
				<div class="col-12 text-center"><b>REAR</b></div>
			</div>

			<div class="form-row mb-5">
				<div class="col-12 col-lg-4" v-show="unseated.length > 0">
					<div class="card mt-3">
						<div class="card-header"><em class="fas fa-user-friends"></em> Unseated Students ({{unseated.length}})</div>
						<ul class="list-group list-group-flush">
							<li class="list-group-item" v-for="student in unseated" :key="student.student_id">
								<span v-show="current_user.school_ids.indexOf(student.school_id) != -1 || canViewOthers">
									<div class="d-flex justify-content-between">
										<span>{{student.lname}}, {{student.fname}}</span>
										<span class="text-right">Grade {{student.grade}}, Student ID {{student.student_id}}</span>
									</div>
								</span>
								<span v-show="current_user.school_ids.indexOf(student.school_id) == -1 && !canViewOthers">{{NSTS_CONFIG['redacted_name']}}</span>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="form-row mb-1">
				<div class="col-12 text-center"><a :href="NSTS_CONFIG['api_server'] + '/runs/' + $route.params.run_id + '/history'" class="btn btn-warning ml-1 mb-1" target="_blank"><em class="fas fa-biohazard"></em> Download Seating History</a></div>
			</div>
		</form>
	</div>
</template>

<script>
	import jQuery from 'jquery';

	export default {
		name: 'SeatingPlan',
		props: ["current_user"],
		data() {
			return {
				run: {run_id: null, seats: [], students: [], pair: null},
				saveBoth: true
			}
		},
		mounted: function()
		{
			this.load();
		},
		computed:
		{
			canEdit: function()
			{
				return this.userHasAction(this.current_user, ['ADMIN', 'EDIT_ANY_SEATING_PLAN', 'EDIT_OWN_SEATING_PLAN'])
			},
			canViewOthers: function()
			{
				return this.userHasAction(this.current_user, ['ADMIN', 'VIEW_OTHER_SCHOOLS', 'VIEW_ALL'])
			},
			canEditOthers: function()
			{
				return this.userHasAction(this.current_user, ['ADMIN', 'EDIT_OTHER_SCHOOLS'])
			},
			hasPair: function()
			{
				// This feature is disabled.
				if(!this.NSTS_CONFIG["allow_autosaving_related_runs"])
				{
					return false;
				}

				return this.run.pair != null;
			},
			hasQualifyingPair: function()
			{
				// This feature is disabled.
				if(!this.NSTS_CONFIG["allow_autosaving_related_runs"])
				{
					return 0;
				}

				// If there's no pair, it doesn't qualify.
				if(!this.hasPair)
				{
					return 0;
				}

				// If the vehicles don't match, it doesn't qualify.
				if(this.run.vehicle_class != this.run.pair.vehicle_class)
				{
					return 1;
				}

				// If any students from the other one aren't in this one, it doesn't qualify.
				// We will allow this run to have students that aren't on the other one.
				var found = false;

				for(var i=0; i<this.run.pair.students.length; i++)
				{
					found = false;

					exit: for(var ii=0; ii<this.run.pair.students[i].length; ii++)
					{
						for(var j=0; j<this.run.students.length; j++)
						{
							for(var jj=0; jj<this.run.students[j].length; jj++)
							{
								if(this.run.pair.students[i][ii].student_id == this.run.students[j][jj].student_id)
								{
									found = true;
									break exit;
								}
							}
						}
					}

					if(!found)
					{
						return 2;
					}
				}

				// If nothing failed yet, its identical.
				return true;
			},
			sortedStudents: function()
			{
				var vm = this;
				var s = [];

				for(var i=0; i<vm.run.students.length; i++)
				{
					for(var ii=0; ii<vm.run.students[i].length; ii++)
					{
						var found = false;

						for(var j=0; j<s.length; j++)
						{
							if(vm.run.students[i][ii].student_id == s[j].student_id)
							{
								found = true;
								break;
							}
						}

						if(!found)
						{
							s.push(vm.run.students[i][ii]);
						}
					}
				}

				return s.sort(function(a, b)
				{
					if(b.seated && !a.seated)
					{
						return -1;
					}
					else if(a.seated && !b.seated)
					{
						return 1;
					}
					else
					{
						if(a["lname"] < b["lname"])
						{
							return -1;
						}
						else if(a["lname"] > b["lname"])
						{
							return 1;
						}
						else
						{
							if(a["fname"] < b["fname"])
							{
								return -1;
							}
							else if(a["fname"] > b["fname"])
							{
								return 1;
							}
						}
					}

					return 0;
				});
			},
			cols: function()
			{
				if(typeof this.run.seats == "undefined")
				{
					return 0;
				}

				if(this.run.seats.length > 1)
				{
					return this.run.seats[1].length;
				}
				else
				{
					return this.run.seats[0].length;
				}
			},
			unseated: function()
			{
				var students = [];
				var seated = false;

				// If seats data is bad, all students are unseated.
				if(this.run.seats == null && this.run.students != null)
				{
					return this.run.students;
				}
				// If students data is also bad, no students are unseated.
				else if(this.run.students == null)
				{
					return [];
				}

				for(var i=0; i<this.run.students.length; i++)
				{
					for(var ii=0; ii<this.run.students[i].length; ii++)
					{
						seated = false;

						exit: for(var row_num=0; row_num<this.run.seats.length; row_num++)
						{
							for(var seat_num=0; seat_num<this.run.seats[row_num].length; seat_num++)
							{
								var seat = this.run.seats[row_num][seat_num];

								if(seat == null)
								{
									continue;
								}

								for(var iii=0; iii<seat.student_id.length; iii++)
								{
									if(seat.student_id[iii] == this.run.students[i][ii].student_id)
									{
										seated = true;
										break exit;
									}
								}
							}
						}

						if(!seated)
						{
							var found = false

							for(var iiii=0; iiii<students.length; iiii++)
							{
								if(students[iiii].student_id == this.run.students[i][ii].student_id)
								{
									found = true;
									break;
								}
							}

							if(!found)
							{
								students.push(this.run.students[i][ii]);
							}
						}
					}
				}

				return students;
			},
			seatLoops: function()
			{
				var x = 1;

				if(this.run.transfer_school_id)
				{
					x++;
				}
				if(this.run.transfer2_school_id)
				{
					x++;
				}
				if(this.run.transfer3_school_id)
				{
					x++;
				}

				return x;
			},
			studentLegs()
			{
				// Quick exit if transfers are not in use.
				if(this.seatLoops == 1)
				{
					return [];
				}

				var legs_cache = [];

				for(var i=0; i<this.run.students.length; i++)
				{
					for(var ii=0; ii<this.run.students[i].length; ii++)
					{
						legs_cache[this.run.students[i][ii].student_id + "|" + i] = true;
					}
				}

				return legs_cache;
			}
		},
		methods:
		{
			load: function()
			{
				var vm = this;

				vm.startLoading();

				this.CORS('GET', "/runs/" + vm.$route.params.run_id, null,
					function(data)
					{
						vm.run = data;

						for(var i=0; i<vm.run.students.length; i++)
						{
							for(var ii=0; ii<vm.run.students[i].length; ii++)
							{
								if(vm.run.students[i][ii] != null)
								{
									vm.run.students[i][ii].seated = vm.isSeated(vm.run.students[i][ii]);
								}
							}
						}

						vm.stopLoading();
					}, function()
					{
						vm.stopLoading();
						vm.showError("Error", "Error loading seating plan.", true, null);
					});
			},
			save: function()
			{
				var vm = this;

				if(vm.hasQualifyingPair === true && vm.saveBoth)
				{
					vm.nerivon_confirm("Are you sure?", "<p>You have indicated that you like to automatically make " + vm.run.pair.run_id + " match " + vm.run.run_id + " when saved.</p><p>Are you sure you want to do this?</p>", "warning", true, function(confirm)
					{
						if(confirm)
						{
							vm.startLoading();
							vm.run.unseated_students = vm.unseated.length;
							vm.run.pair.seats = JSON.parse(JSON.stringify(vm.run.seats));
							vm.run.pair.unseated_students = vm.run.unseated_students;
							vm.run.pair.autopilot = vm.run.autopilot;

							// Transfers: seats on the paired run need to be reversed.
							for(var i=0; i<vm.run.pair.seats.length; i++)
							{
								for(var ii=0; ii<vm.run.pair.seats[i].length; ii++)
								{
									if(vm.run.pair.seats[i][ii] == null)
									{
										continue;
									}

									// Reverse the students in this seat.
									// We have to account for null students for unused legs of the run.
									try
									{
										vm.run.pair.seats[i][ii].student = vm.run.pair.seats[i][ii].student.splice(0, vm.seatLoops).reverse();

										while(vm.run.pair.seats[i][ii].student.length < 4)
										{
											vm.run.pair.seats[i][ii].student.push(null);
										}
									}
									catch(e)
									{
										// pass
									}

									// Reverse the student IDs in this seat.
									// We have to account for null student IDs for unused legs of the run.
									try
									{
										vm.run.pair.seats[i][ii].student_id = vm.run.pair.seats[i][ii].student_id.splice(0, vm.seatLoops).reverse();

										while(vm.run.pair.seats[i][ii].student_id.length < 4)
										{
											vm.run.pair.seats[i][ii].student_id.push(null);
										}
									}
									catch(e)
									{
										// pass
									}
								}
							}

							vm.CORS("PUT", "/runs/" + vm.run.run_id, JSON.stringify(vm.run),
								function(data1)
								{
									vm.CORS("PUT", "/runs/" + vm.run.pair.run_id, JSON.stringify(vm.run.pair),
										function(data2)
										{
											vm.run = data1;
											vm.run.pair = data2;

											for(var i=0; i<vm.run.students.length; i++)
											{
												for(var ii=0; ii<vm.run.students[i].length; ii++)
												{
													if(vm.run.students[i][ii] != null)
													{
														vm.run.students[i][ii].seated = vm.isSeated(vm.run.students[i][ii]);
													}
												}
											}

											vm.stopLoading();
											vm.showSuccess("Saved", "<p>Your seating plans for " + vm.run.run_id + " and " + vm.run.pair.run_id + " were saved.</p><p>The old versions were archived for contract tracing purposes.</p>", true, null);
										}, function(response)
										{
											vm.stopLoading();
											vm.showError("Error", vm.run.run_id + " was saved but there was an error saving " + vm.run.pair.run_id + ": " + response.responseText, true, null);
										});
								}, function(response)
								{
									vm.stopLoading();
									vm.showError("Error", "Error saving " + vm.run.run_id + ": " + response.responseText, true, null);
								});
						}
						else
						{
							vm.startLoading();
							vm.run.unseated_students = vm.unseated.length;

							vm.CORS("PUT", "/runs/" + vm.run.run_id, JSON.stringify(vm.run),
								function(data)
								{
									vm.run = data;

									for(var i=0; i<vm.run.students.length; i++)
									{
										for(var ii=0; ii<vm.run.students[i].length; ii++)
										{
											if(vm.run.students[i][ii] != null)
											{
												vm.run.students[i][ii].seated = vm.isSeated(vm.run.students[i][ii]);
											}
										}
									}

									vm.stopLoading();
									vm.showSuccess("Saved", "<p>Your seating plan for " + vm.run.run_id + " was saved.</p><p>The old version was archived for contract tracing purposes.</p>", true, null);
								}, function(response)
								{
									vm.stopLoading();
									vm.showError("Error", "Error saving " + vm.run.run_id + ": " + response.responseText, true, null);
								});
						}
					});
				}
				else
				{
					vm.startLoading();
					vm.run.unseated_students = vm.unseated.length;

					vm.CORS("PUT", "/runs/" + vm.run.run_id, JSON.stringify(vm.run),
						function(data)
						{
							vm.run = data;

							for(var i=0; i<vm.run.students.length; i++)
							{
								for(var ii=0; ii<vm.run.students[i].length; ii++)
								{
									if(vm.run.students[i][ii] != null)
									{
										vm.run.students[i][ii].seated = vm.isSeated(vm.run.students[i][ii]);
									}
								}
							}

							vm.stopLoading();
							vm.showSuccess("Saved", "<p>Your seating plan for " + vm.run.run_id + " was saved.</p><p>The old version was archived for contract tracing purposes.</p>", true, null);
						}, function(response)
						{
							vm.stopLoading();
							vm.showError("Error", "Error saving " + vm.run.run_id + ": " + response.responseText, true, null);
						});
				}
			},
			seatClass: function(seat_num)
			{
				if(this.cols == 7 && (seat_num == 1 || seat_num == 5))
				{
					return "col-1";
				}
				else if(this.cols == 7)
				{
					return "col-2";
				}
				else if(this.cols == 6)
				{
					return "col-2";
				}
				else if(this.cols == 5 && seat_num == 2)
				{
					return "col-4";
				}
				else if(this.cols == 5 && seat_num != 2)
				{
					return "col-2";
				}
				else if(this.cols == 4)
				{
					return "col-3";
				}
				else if(this.cols == 3)
				{
					return "col-4";
				}
				else if(this.cols == 2)
				{
					return "col-6";
				}
				else
				{
					return "col-12";
				}
			},
			isSeated: function(student)
			{
				if(student == null)
				{
					return false;
				}

				for(var i=0; i<this.unseated.length; i++)
				{
					if(this.unseated[i].student_id == student.student_id)
					{
						return false;
					}
				}

				return true;
			},
			tooltip: function(seat, index, e)
			{
				var btn = jQuery(e.target);
				var tip = "";
				btn.tooltip("dispose");

				if(seat.accessible == true)
				{
					tip = "This is a wheelchair space.";
				}

				if(seat == null || seat.available == false || seat.priority == 1)
				{
					tip += (tip ? "\n" : "") + this.NSTS_CONFIG["do_not_use_tooltip"];
				}
				else if(seat.student[index] != null)
				{
					tip += (tip ? "\n" : "");

					if(this.current_user.school_ids.indexOf(seat.student[index].school_id) != -1 || this.canViewOthers)
					{
						tip += '<div class="text-left"><b>First Name:</b> ' + seat.student[index].fname + '</div>';
						tip += '<div class="text-left"><b>Last Name:</b> ' + seat.student[index].lname + '</div>';
						if(this.NSTS_CONFIG["show_school_id"])
						{
							tip += '<div class="text-left"><b>School:</b> ' + seat.student[index].school_id + '</div>';
						}
						if(this.NSTS_CONFIG["show_homeroom"])
						{
							tip += '<div class="text-left"><b>Home Room:</b> ' + seat.student[index].homeroom + '</div>';
						}
						if(this.NSTS_CONFIG["show_grade"])
						{
							tip += '<div class="text-left"><b>Grade:</b> ' + seat.student[index].grade + '</div>';
						}
						if(this.NSTS_CONFIG["show_student_id"])
						{
							tip += '<div class="text-left"><b>Student ID:</b> ' + seat.student[index].student_id + '</div>';
						}
						if(this.NSTS_CONFIG["show_stop_description"])
						{
							tip += '<div class="text-left"><b>Stop ID:</b> ' + seat.student[index].stop_description + '</div>';
						}
						if(this.NSTS_CONFIG["show_address"])
						{
							tip += '<div class="text-left"><b>Address:</b> ' + seat.student[index].street_number + ' ' + seat.student[index].street_name + (seat.student[index].apartment_number ? " (" + seat.student[index].apartment_number + ")" : "") + '<br>' + seat.student[index].postalcode + '</div>';
						}
					}
					else
					{
						tip += '<div class="text-left">This student is from another school and you do not have permission to view them.</div>';
					}
				}
				else if(seat.priority == 2 && this.NSTS_CONFIG["overflow_tooltip"])
				{
					tip += (tip ? "\n" : "") + this.NSTS_CONFIG["overflow_tooltip"];
				}

				if(tip != "")
				{
					btn.attr("data-html", true);
					btn.attr("title", tip);
					btn.tooltip("show");
				}
			},
			reseat: function(new_seat, index)
			{
				this.run.autopilot = 0;

				if(new_seat.student[index] == null && new_seat.student_id[index] == null)
				{
					return;
				}

				// Because the select list is bound to student_id, we need to update the student object too.
				exit: for(var i=0; i<this.run.students.length; i++)
				{
					for(var ii=0; ii<this.run.students[i].length; ii++)
					{
						if(this.run.students[i][ii].student_id == new_seat.student_id[index])
						{
							new_seat.student[index] = this.run.students[i][ii];
							break exit;
						}
					}
				}

				for(var row_num=0; row_num<this.run.seats.length; row_num++)
				{
					for(var seat_num=0; seat_num<this.run.seats[row_num].length; seat_num++)
					{
						var seat = this.run.seats[row_num][seat_num];

						if(seat == null || seat == new_seat)
						{
							// If a student is unseated, clear their seat.
							if(new_seat.student_id[index] == null)
							{
								new_seat.student[index] = null;
							}
							else if(new_seat.student[index] == null)
							{
								new_seat.student_id[index] = null;
							}

							continue;
						}

						if(seat.student_id[index] == new_seat.student_id[index])
						{
							seat.student[index] = null;
							seat.student_id[index] = null;
						}
					}
				}

				if(new_seat.student[index] != null)
				{
					new_seat.student[index].seated = this.isSeated(new_seat.student[index]);
				}

				jQuery("[data-html]").tooltip("dispose");
			},
			autofill: function()
			{
				var vm = this;

				vm.nerivon_confirm("Are you sure?", "<p>Any changes you've made will be <b>OVERRIDDEN</b>.</p><p>ALL students will be reseated.</p><p>Nothing will be committed until you save this seating plan.</p><p>Continue?</p>", "warning", true, function(confirm)
				{
					if(confirm)
					{
						vm.startLoading();

						vm.CORS('GET', "/autofill/" + vm.$route.params.run_id, null,
							function(data)
							{
								vm.run = data;

								for(var i=0; i<vm.run.students.length; i++)
								{
									for(var ii=0; ii<vm.run.students[i].length; ii++)
									{
										if(vm.run.students[i][ii] != null)
										{
											vm.run.students[i][ii].seated = vm.isSeated(vm.run.students[i][ii]);
										}
									}
								}

								vm.stopLoading();
							}, function()
							{
								vm.stopLoading();
								vm.showError("Error", "Error loading seating plan.", true, null);
							});
					}
				});
			},
			refresh: function()
			{
				var vm = this;

				vm.nerivon_confirm("Are you sure?", "<p>Data on this seating plan is cached for performance reasons.</p><p>This will refresh student information from the database.</p><p class='text-left'>This can be useful if:</p><ul class='text-left'><li>Student information is incorrect or out of date.</li><li>Student tooltips are incorrect or out of date.</li><li>You have \"ghost students\" (blank boxes while editing).</li></ul><p>No manual changes will be overwritten.</p><p>Nothing will be committed until you save this seating plan.</p><p>Continue?</p>", "warning", true, function(confirm)
				{
					if(confirm)
					{
						vm.startLoading();

						vm.CORS('GET', "/refresh/" + vm.$route.params.run_id, null,
							function(data)
							{
								vm.run = data;

								for(var i=0; i<vm.run.students.length; i++)
								{
									for(var ii=0; ii<vm.run.students[i].length; ii++)
									{
										if(vm.run.students[i][ii] != null)
										{
											vm.run.students[i][ii].seated = vm.isSeated(vm.run.students[i][ii]);
										}
									}
								}

								vm.stopLoading();
							}, function()
							{
								vm.stopLoading();
								vm.showError("Error", "Error loading seating plan.", true, null);
							});
					}
				});
			},
			reset: function()
			{
				var vm = this;

				vm.nerivon_confirm("Are you sure?", "<p>ALL students will be unseated.</p><p>Continue?</p>", "warning", true, function(confirm)
				{
					if(confirm)
					{
						for(var row_num=0; row_num<vm.run.seats.length; row_num++)
						{
							for(var seat_num=0; seat_num<vm.run.seats[row_num].length; seat_num++)
							{
								var seat = vm.run.seats[row_num][seat_num];

								if(seat == null || seat.student == null)
								{
									continue;
								}

								for(var i=0; i<seat.student.length; i++)
								{
									vm.$set(seat.student, i, null);
									vm.$set(seat.student_id, i, null);
								}
							}
						}

						for(i=0; i<vm.run.students.length; i++)
						{
							for(var ii=0; ii<vm.run.students[i].length; ii++)
							{
								vm.$set(vm.run.students[i][ii], "seated", false);
							}
						}
					}
				});
			},
			studentOnLeg(student_id, leg)
			{
				// Quick exit if transfers are not in use.
				if(this.seatLoops == 1)
				{
					return true;
				}

				return this.studentLegs[student_id + "|" + leg];
			}
		}
	}
</script>
